module.exports = __webpack_public_path__ + "static/media/edit_note_black_24dp.ccca92e7.svg";